import { useState, useEffect } from 'react'




const Bool = ({contentTypeId, contentSetting, contentValue, setIsDraft, setLastSaved}) => {
    const[cValue, setCValue] = useState(contentValue)
    const [val, setVal] = useState('')


    useEffect(() => {
        const getValue = (contentSetting, cValue) => {
            if(cValue){
                if(cValue.contentDraft !== ""){
                    setVal(cValue.contentDraft)
                    setIsDraft(true)
                }else if(cValue.contentPublished !== ""){
                    setVal(cValue.contentPublished)
                }
            }else{
                setVal(contentSetting.defaultValue)
                setIsDraft(true)
            }
        }
        getValue(contentSetting, cValue)
    },[cValue])

    const updateValue = async (checked) => {
        console.log(checked)
        var data = JSON.stringify( {
            value: checked
            ,settingId: contentSetting.id
            ,settingAlias: contentSetting.settingAlias
        })
        const res = await fetch(`${global.config.Api.url}${global.config.Editor.publicToken}/ContentType/${contentTypeId}/values${cValue ? `/${cValue.id}` : ''}`,{
            method:(cValue ? 'PUT' : 'POST'),
            headers:{
                'Authorization':'Basic ' + global.config.Editor.authToken
                ,'Content-Type': 'application/json'
            },
            body: data
        })
        if(!cValue){
            const response = await res.json()
            setCValue(response)
        }
        setLastSaved(new Date())
    }
/*
    const handleBlur = async e => {
        e.preventDefault()
        console.log(e.target.checked)
        setVal(e.target.checked.toString())
        cValue.contentDraft = e.target.checked.toString()
        setCValue(cValue)
        await updateValue(e.target.checked.toString())
    }
  */  
    const handleBlur = async (checked) => {
        console.log(checked)
        setVal(checked)
        if(cValue){
            cValue.contentDraft = checked
            setCValue(cValue)
        }
        await updateValue(checked)
        setIsDraft(true)
    }

    return (
        <div className="cc_value_list_item_content">
            <input type="checkbox" checked={val === "true" && true} onChange={ e => handleBlur(val === "true" ? "false" : "true") } />
        </div>
    )
}

export default Bool
